export default "__VITE_ASSET__fgQigBe9__"